import { Component, OnInit } from "@angular/core";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { Projet } from "src/app/core/models/project";
import { environment } from "src/environments/environment";
import { DatePipe } from "@angular/common";
import { BonSortieTemplate } from "src/app/core/template-invoice/bon-sortie";
import { AuthenticationService } from "src/app/core/services/auth.service";
import { ToastService } from "src/app/core/services/toast.service";
import { BonSortie } from "src/app/core/models/bonSortie";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BaseListComponent } from "src/app/modules/baseList.component";
import { PROJET_SELECTIONNABLE_FILTER } from "src/app/core/const/projet-filters";

@Component({
	selector: "cmn-rest-a-livre",
	templateUrl: "rest-a-livre.component.html",
	styleUrl: "rest-a-livre.component.scss",
	//standalone: true, // Enable standalone component
	//imports: [SharedModule],
})
export class RestALivreCmnComponent extends BaseListComponent implements OnInit {
	protected projets: Projet[] = [];
	protected articles: any[] = [];
	protected articlesFilter: any[] = [];
	protected demandes: any[] = [];
	protected demandesFilter: { id: number; numero: string; projetId?: number }[] = [];
	protected sorties: any[] = [];
	protected bonSortie: BonSortie = {
		createdAt: undefined,
		magasinier: undefined,
		projet: undefined,
		articles: [],
		numero: "",
		commentaire: "",
	};
	// forms
	protected formFilter: FormGroup;
	protected formBonSortie: FormGroup;
	protected commantaireControl = new FormControl();
	// is
	protected isSubmitting = false;
	// filters
	protected filtersparams = "";
	protected filterProjet = "";
	protected filterDate = "";

	// populate
	constructor(
		private datePipe: DatePipe,
	) {
		super();
		this.formBonSortie = this.fb.group({
			articles: this.fb.array([]),
		});
	}
	ngOnInit() {
		this.authService.currentUser$.subscribe((user) => {
			this.bonSortie.magasinier = user;
		});
		this.initialiseFormFilter();
		this.initializedData();
	}
	// init data function
	private initialiseFormFilter(): void {
		this.formFilter = this.fb.group({
			projet: [null, [Validators.required]],
			date: [null],
			fullProject: [null],
			livraison: [null],
			demande: [null],
		});
	}

	private initializedForm(data: any): void {
		this.articlesForm.clear();
		let filteredArticles = data;
		if (this.formFilter.get("livraison")?.value === "rest") {
			filteredArticles = filteredArticles.filter((article) => article.resteALivrer > 0);
		}
		const selectedDemandeId = this.formFilter.get("demande")?.value;
		if (selectedDemandeId) {
			filteredArticles = filteredArticles.filter((article) => (article.demandes || []).some((d: any) => d.id === selectedDemandeId));
		}
		if (filteredArticles.length > 0) {
			filteredArticles.forEach((article) => {
				const articleGroup = this.createFormGroupArticle(article);
				this.articlesForm.push(articleGroup);
			});
		}
	}

	private rebuildDemandesFilter(): void {
		const map = new Map<number, string>();
		(this.articles || []).forEach((article) => {
			(article.demandes || []).forEach((d: any) => {
				if (d?.id && !map.has(d.id)) map.set(d.id, d.numero);
			});
		});
		this.demandesFilter = Array.from(map, ([id, numero]) => ({ id, numero }));
	}

	private initializedDataProject() {
		this.restApiService.get("projets", { filters: this.filters, pagination: { page: 0, pageSize: environment.pageSizeAll }, jwt: "" }).subscribe({
			next: (project) => {
				this.projets = project.data;
			},
			error: (error) => {},
		});
	}

	private initializedDataDemandes() {
		const statusFilter =
			"filters[$or][0][statusDemande]=en preparation" +
			"&filters[$or][1][statusDemande]=semi-livre" +
			"&filters[$or][2][statusDemande]=livre";
		let demandesFilters = statusFilter;
		if (this.authService.isDemandeur() || this.authService.isChefChantier()) {
			demandesFilters += "&filters[demandeur]=" + this.authService.currentUserValue.id;
		}
		this.restApiService
			.get("demandes", {
				filters: demandesFilters,
				populate: "populate[projet]=true",
				pagination: { page: 0, pageSize: environment.pageSizeAll },
				sort: { field: "id", order: "desc" },
			})
			.subscribe({
				next: (response) => {
					this.demandesFilter = (response.data || []).map((d: any) => ({ id: d.id, numero: d.numero, projetId: d.projet?.id }));
				},
				error: () => {},
			});
	}

	private initializeFilterListeners() {
		this.formFilter.get("date").valueChanges.subscribe((date) => {
			const formattedValue = this.datePipe.transform(date, "yyyy-MM-dd");
			this.filterDate = "&filters[$and][0][createdAt][$gt]=" + formattedValue;
			this.getDemandeByFilters();
		});
		this.formFilter.get("projet").valueChanges.subscribe((projet) => {
			this.filterProjet = "&filters[projet]=" + projet;
			this.getDemandeByFilters();
		});
		this.formFilter.get("livraison").valueChanges.subscribe((filter) => {
			this.initializedForm(this.articles);
		});
		this.formFilter.get("demande").valueChanges.subscribe((demandeId) => {
			if (demandeId) {
				const sel = this.demandesFilter.find((d) => d.id === demandeId);
				if (sel?.projetId && this.formFilter.get("projet")?.value !== sel.projetId) {
					this.formFilter.get("projet")?.setValue(sel.projetId);
					return;
				}
			}
			this.initializedForm(this.articles);
		});
	}

	private initializedData(): void {
		if (this.authService.isDemandeur() || this.authService.isChefChantier()) {
			this.filters = PROJET_SELECTIONNABLE_FILTER + "&filters[demandeurs]=" + this.authService.currentUserValue.id;
		} else {
			this.filters = PROJET_SELECTIONNABLE_FILTER;
		}
		//initialized projects
		this.initializedDataProject();
		this.initializedDataDemandes();
		// inialised filters listeners
		this.initializeFilterListeners();
		//this.initializedDataDemandes();
	}
	// create forms
	private createFormGroupArticle(article: any): FormGroup {
		const demandes = this.fb.array(article.demandes.map((demande) => this.createFormGroupDemande(demande)));
		const articleForm = this.fb.group({
			id: [article.article.id],
			designation: [article.article.designation],
			code: [article.article.code],
		});

		return this.fb.group({
			article: articleForm,
			qteDemandee: [article.qteDemandee],
			qtePreparee: [article.qtePreparee],
			qteAAcheter: [article.qteAAcheter],
			qteAchetee: [article.qteAchetee],
			qteLivree: [article.qteLivree],
			resteALivrer: [article.resteALivrer],
			demandes: demandes,
			sorties: [article.bonsSorties],
			qteALivre: [
				0,
				{
					validators: [Validators.required, Validators.min(1)],
				},
			],
			stockTheorique: [null],
		});
	}

	private createFormGroupDemande(demande: any): FormGroup {
		return this.fb.group({
			id: [demande.id],
			numero: [demande.numero],
			publicationDate: [demande.publicationDate],
			qteDemandee: [demande.qteDemandee],
			qtePreparee: [demande.qtePreparee],
			qteAAcheter: [demande.qteAAcheter],
			qteLivree: [demande.qteLivree],
			resteALivrer: [demande.resteALivrer],
		});
	}

	public get articlesForm() {
		return this.formBonSortie.get("articles") as FormArray;
	}
	// GETRS
	protected get currentDate(): string {
		const currentDate = new Date();
		currentDate.setDate(currentDate.getDate() - 3);
		return currentDate.toISOString().split("T")[0];
	}
	get currentSelectedProject() {
		return this.projets.find((project) => project.id === this.formFilter.get("projet").value.id);
	}
	private getDemandeByFilters() {
		this.isDataLoading = true;
		this.filtersparams = this.filterProjet + this.filterDate;
		this.restApiService.getCustom("projets/" + this.formFilter.get("projet").value + "/reste-a-livrer/").subscribe({
			next: (response) => {
				this.articles = response.data;
				this.initializedForm(response.data);
				this.isDataLoading = false;
			},
			error: (error) => {
				this.isDataLoading = false;
			},
		});
	}

	// ACTIONS
	protected filterArticle(event: any) {
		let articlesFilter = [];
		if (event.nom === "rest") {
			articlesFilter = this.articles.filter((article) => article.resteALivrer > 0);
		} else {
			articlesFilter = this.articles;
		}
		this.initializedForm(articlesFilter);
	}

	/******************* shared dmd-a-alivrer */

	protected onSelectProject(event) {
		this.logger.info(event);
		this.formFilter.get("fullProject").setValue(event);
	}

	// modal
	protected openModalDmd(event: MouseEvent, content: any, data) {
		event.stopPropagation();
		this.demandes = data;
		const modalRef = this.modalService.open(content, { size: "lg", centered: true });
		modalRef.result.then((result) => {
			if (result) {
			}
		});
	}
	protected openModalBS(event: MouseEvent, content: any, data) {
		event.stopPropagation();
		this.sorties = data;
		const modalRef = this.modalService.open(content, { size: "lg", centered: true });
		modalRef.result.then((result) => {
			if (result) {
			}
		});
	}
}
